import { Link } from "@/i18n/routing";
import { IconBreadCrumb } from "@repo/assets/images";
const BreadCrumb = props => {
  const {
    items
  } = props;
  return <div className="p-4 px-0 md:py-6" data-sentry-component="BreadCrumb" data-sentry-source-file="BreadCrumb.jsx">
      <ul className="flex min-w-0 items-center">
        {items?.map((item, index) => {
        const isLastCrumb = index === items.length - 1;
        return <li key={item?.label} className={`flex min-w-0 items-center text-sm ${isLastCrumb ? "shrink grow" : "shrink-0"}`}>
              {isLastCrumb ? <span className="text-breadcrumb-active truncate font-medium" title={item?.label}>
                  {item?.label}
                </span> : <>
                  <Link href={item?.url} className="text-breadcrumb-text max-w-[12ch] truncate font-medium hover:underline" title={item?.label}>
                    {item?.label}
                  </Link>
                  <IconBreadCrumb className="text-breadcrumb-icon mx-[6px] shrink-0 fill-current rtl:rotate-180" />
                </>}
            </li>;
      })}
      </ul>
    </div>;
};
export default BreadCrumb;